/*
 * Copyright (c) 2019 Honeywell International, Inc. All rights reserved.
 *
 * This file contains trade secrets of Honeywell International, Inc.  No part
 *  may be reproduced or transmitted in any form by any means or for any
 *  purpose without the express written permission of Honeywell.
 *
 */

import React, { Component } from 'react';
import { ToastContainer, toast } from 'react-toastify';
import { Notification } from '@scuf/common';
import './ToastNotification.scss';

interface IToastNotificationProps {
}

// @ts-ignore
const ToastNotifications = ({ closeToast, title, detailMessage, severity }) => (
  <Notification
    className="toast-notification"
    severity={severity}
    onCloseClicked={closeToast}
    hasIcon={true}
    title={title}
  >
    {detailMessage}
  </Notification>
);

export class ToastNotification extends Component<IToastNotificationProps> {
  constructor(props: IToastNotificationProps) {
    super(props);
  }

  notify = (title: string, severity: string, detailMessage: string) => {
    toast(
      <ToastNotifications
        closeToast={false}
        title={title}
        severity={severity}
        detailMessage={detailMessage}
      />
    );
  }

  render() {
    return (
      <ToastContainer
        hideProgressBar={true}
        closeOnClick={false}
        closeButton={false}
        newestOnTop={true}
        position="bottom-right"
        toastClassName="test"
      />
    );
  }
}
